module.exports = __webpack_public_path__ + "h5/img/icon_xx.a4c7caa0.png";